import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_ARTICLE_SCHEMA_LITERAL = {
    title: 'Schéma Articles',
    description: 'Décrit un article',
    version: 4,
    keyCompression: false,
    //primaryKey: 'AR_REF',
    primaryKey : { key : 'AR_REF_PK', fields : ['USER_ID', 'AR_REF'], separator : '_' },
    type: 'object',
    properties: {
        AR_REF_PK: { type: 'string', maxLength: 60 },
        USER_ID: { type: 'string' },
        SITEGID: { type: 'string' },
        AR_REF: { type: 'string', default: '', maxLength: 20 },
        AR_DESIGN: { type: 'string', default: '' },
        FA_FAMNV1: { type: 'string' },
        FA_FAMNV1LIB: { type: 'string' },
        FA_FAMNV2: { type: 'string' },
        FA_FAMNV2LIB: { type: 'string' },
        AR_SUIVISTOCKLIB : { type: 'string' },
        AR_TYPELIB: { type: 'string' },
        AR_NOMENCLLIB: { type: 'string' },
        AR_GAMME1: { type: 'number' },
        AR_GAMME1LIB: { type: 'string' },
        AR_GAMME2: { type: 'number' },
        AR_GAMME2LIB: { type: 'string' },
        AR_CAT1LIB: { type: 'string' },
        AR_CAT2LIB: { type: 'string' },
        AR_CAT3LIB: { type: 'string' },
        AR_CAT4LIB: { type: 'string' },
        AR_CONDITION: { type: 'number' },
        AR_CONDITIONLIB: { type: 'string' },
        AR_PRIXACH: { type: 'number' },
        AR_PRIXVEN: { type: 'number' },
        AR_PRIXTTCLIB: { type: 'string' },
        AR_UNITEVEN: { type: 'string' },
        AR_CODEBARRE: { type: 'string' },
        AR_FACTPOIDS: { type: 'number' },
        AR_POIDSNET: { type: ['number', 'null'] },
        AR_POIDSBRUT: { type: ['number', 'null'] },
        AR_NOTIMP: { type: 'boolean' },
        ARTSTOCK_TOT: { type: 'number' },
        STOCKESTIME_TOT: { type: 'number' },
        ARTSTOCK_ITEMS_JSON: { type: ['string', 'null'] },
        ARTVTECLU_ITEMS_JSON: { type: ['string', 'null'] },
        EXTRA: { type: ['string', 'null'] }
    },
    required: [ 'AR_REF', 'AR_DESIGN', 'AR_PRIXVEN', 'AR_CONDITION', 'AR_TYPELIB', 'AR_NOMENCLLIB']
} as const;

const schemaTyped = toTypedRxJsonSchema(F_ARTICLE_SCHEMA_LITERAL);
export type RxFArticleDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_ARTICLE_SCHEMA: RxJsonSchema<RxFArticleDocumentType> = F_ARTICLE_SCHEMA_LITERAL;
